var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMovement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1a6001",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 198.036 198.036",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.599,175.32c-1.272,0-2.499-0.168-3.722-0.57l-13.614-4.494v19.034c0,4.831,3.857,8.746,8.688,8.746 c4.833,0,8.689-3.915,8.689-8.746v-13.97c0,0-0.01,0-0.033,0H125.599L125.599,175.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.099,37.238c9.03,0,16.356-7.229,16.356-16.142c0-8.913-7.326-16.139-16.356-16.139 c-9.032,0-16.356,7.226-16.356,16.139C89.743,30.009,97.065,37.238,106.099,37.238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.604,40.779c-0.84-0.48-2.604-1.221-4.592-1.221c-8.29,0-32.638,0-32.638,0C62.585,31.034,65.642,7.686,65.779,6.721 c0.5-3.181-1.675-6.152-4.857-6.651c-3.181-0.494-6.203,1.683-6.702,4.865c-1.87,11.917,2.556,36.837,32.234,46.011v70.248 l-8.534,26.5c-1.473,4.574,1.021,9.481,5.584,10.988l39.357,12.989c0.91,0.302,1.834,0.442,2.744,0.442 c3.673,0,7.094-2.33,8.307-6.008c1.514-4.588-0.979-9.533-5.565-11.049l-29.9-9.867c-0.67-0.223-1.037-0.942-0.82-1.615 l6.565-20.396h4.07v21.771l17.379,5.774V54.995c10.329,12.254,6.709,38.296,4.101,48.457c-0.806,3.118,1.074,6.299,4.191,7.106 c0.49,0.125,0.983,0.185,1.467,0.185c2.595,0,4.963-1.745,5.644-4.374C141.57,104.33,153.653,56.201,126.604,40.779z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovement);
export default __webpack_public_path__ + "static/media/movement.8a5e6a4367a20527f9d39726691fef33.svg";
export { ForwardRef as ReactComponent };